import React from 'react';
import {useWindowDimensions, View} from 'react-native';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {capGQV} from '/util/attribute.util';

import {styles} from './FqvGqvScCount.style';

interface FqvGqvScCountProps {
  tt: (key: string, value: string) => string;
  item: {
    fqv: string;
    gqv: string;
    seniorCoachTeamsCount: number;
  };
}

export const FqvGqvScCount: React.FC<FqvGqvScCountProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = {fqv: '', gqv: '', seniorCoachTeamsCount: 0},
}: FqvGqvScCountProps) => {
  const {fontScale} = useWindowDimensions();
  const isLargeFont = fontScale > 1.2;
  const fqv = get(item, 'fqv', '');
  const gqv = get(item, 'gqv', '');
  const seniorCoachTeamsCount = get(item, 'seniorCoachTeamsCount', '');

  return (
    <View
      style={[
        styles.attributes,
        isLargeFont && {flexDirection: 'column', alignItems: 'flex-start'},
      ]}>
      <View
        style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="button"
          emphasis="medium">
          {tt('fqv', 'FQV')}{' '}
        </Text>
        <FormattedNumber
          // @ts-expect-error TS(2322): Type '{ testID: any; value: any; textEmphasis: str... Remove this comment to see the full error message
          testID={Reports.reportCoachFqv}
          value={fqv}
          textEmphasis="medium"
          boldText={false}
        />
        {!isLargeFont && (
          <Text allowFontScaling maxFontSizeMultiplier={2} emphasis="medium">
            {' '}
            ·{' '}
          </Text>
        )}
      </View>
      <View
        style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="button"
          emphasis="medium">
          {tt('gqv', 'GQV')}{' '}
        </Text>
        <FormattedNumber
          // @ts-expect-error TS(2322): Type '{ testID: any; value: any; textEmphasis: str... Remove this comment to see the full error message
          testID={Reports.reportCoachGQV}
          value={capGQV(gqv)}
          textEmphasis="medium"
          boldText={false}
        />
        {!isLargeFont && (
          <Text allowFontScaling maxFontSizeMultiplier={2} emphasis="medium">
            {' '}
            ·{' '}
          </Text>
        )}
      </View>
      <View
        style={{flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="button"
          emphasis="medium">
          {tt('scTeams', 'SC Teams')}{' '}
        </Text>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          emphasis="medium"
          testID={Reports.reportCoachSCTeams}>
          {seniorCoachTeamsCount}
        </Text>
      </View>
    </View>
  );
};

export default withTranslation('report.record.fqvGqvScCount')(FqvGqvScCount);
